import React from "react"
import Opportunities from "./Opportunities"
import Diversification from "./Diversification"
import Costs from "./Costs"
import Convenience from "./Convenience"
import OpportunitiesMobile from "./OpportunitiesMobile"
import CostsMobile from "./CostsMobile"
import styled from "styled-components"
import { mainLightGray, fontBlue } from "../../styles"

const FeaturesSection = () => {
  return (
    <Wrapper id="features-section">
      <div className="container">
        <div className="row justify-content-around text-center">
          <div className="col-lg-8">
            <h2>What Your Investments May Be Missing Out On</h2>
          </div>
        </div>
        <Opportunities id="opportunities" className="py-5" />
        <OpportunitiesMobile id="opportunities-mobile" className="py-5" />
        <Diversification className="py-5" />
        <Costs id="costs" className="py-5" />
        <CostsMobile id="costs-mobile" className="py-5" />
        <Convenience className="py-5" />
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  background-color: ${mainLightGray};
  padding: 4rem 0;
  h2 {
    margin: 0 0 10rem 0;
  }
  h3 {
    color: ${fontBlue};
    margin: 2rem 0;
  }
  @media screen and (max-width: 870px) {
    #opportunities {
      display: none;
    }
    #costs {
      display: none;
    }
  }
  @media screen and (min-width: 1024px) {
    #opportunities-mobile {
      display: none;
    }
    #costs-mobile {
      display: none;
    }
  }
`

export default FeaturesSection
